// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import PoolInventoryByPoolPkgCode from './poolInventoryByPoolPkgCode';
import React from 'react';

function PoolInventoryByPoolPkgCodePage () {

    return (
        <AuthenticatedPage className="atp-page atp-pool-pool-inventory-by-pkg-code-page">
            <PoolInventoryByPoolPkgCode />
        </AuthenticatedPage>
    );

}
PoolInventoryByPoolPkgCodePage.displayNAme = 'PoolInventoryByPoolPkgCodePage';

export default PoolInventoryByPoolPkgCodePage;
